import { useParams, useSearchParams } from 'react-router';

const TEXT: Record<string, { title: string; body: string }> = {
  danke: { title: 'Vielen Dank, die Zahlung ist eingegangen', body: 'Ihre Zahlung wird der Rechnung automatisch zugeordnet. Sie müssen nichts weiter tun.' },
  abgebrochen: { title: 'Die Zahlung wurde abgebrochen', body: 'Es wurde nichts abgebucht. Sie können den Link aus der E-Mail jederzeit noch einmal öffnen und die Rechnung bezahlen.' },
  ungueltig: { title: 'Dieser Link ist nicht mehr gültig', body: 'Vielleicht wurde er zurückgezogen, oder die Rechnung ist schon bezahlt. Wenden Sie sich bitte an den Absender der Rechnung.' },
  fehler: { title: 'Die Bezahlseite ist gerade nicht erreichbar', body: 'Es wurde nichts abgebucht. Bitte versuchen Sie es später noch einmal oder wenden Sie sich an den Absender der Rechnung.' },
};

/** Öffentliche Seite nach dem Bezahlen über einen Zahlungslink (KON-189). Sie braucht keine Anmeldung und nennt keine Einzelheiten der Rechnung. */
export function PaymentResultPage() {
  const { result = '' } = useParams();
  const [params] = useSearchParams();
  const base = TEXT[result] ?? TEXT.ungueltig!;
  const already = result === 'danke' && params.get('schon') === '1';
  return (
    <div className="center-screen">
      <div className="card narrow" role="status">
        <h1>{already ? 'Diese Rechnung ist bereits bezahlt' : base.title}</h1>
        <p>{already ? 'Es ist nichts weiter zu tun. Vielen Dank.' : base.body}</p>
      </div>
    </div>
  );
}
